<template>

<div class="blocks-wrapper">

	<app-text v-for="(block, index) in blocks" :key="index" :text="block" class="block" />

</div>

</template>

<script>

export default {

	props: ['text'],

    computed: {

        blocks: function() {

            var blocks = []

            this.$_.each(this.text, function(text) {

                var block = this.$_.findWhere(this.$store.getters['data/decision/blocks'], {
                    id: text
                })

                console.log(block)

                if (block) {

                    if (block.visibility.enabled === 1 || this.$store.getters['logic/evaluate'](block.visibility.logic)) {

                        blocks.push(block.text)

                    }

                }

            }.bind(this))

            return blocks

        }

    }

}

</script>

<style scoped>

.block {
    margin-bottom: 16px;
}

.block:last-child {
    border-bottom: 0px;
}

</style>